import React from 'react'

interface ITabItemProps {
  name: string
  title: string
  buttons?: JSX.Element
  disabled?: boolean | string
  hide?: boolean | string
  label?: JSX.Element | null
  children?: React.ReactNode
}

interface InjectedProps {
  registerField: (tab: string, field: string) => void
}

const TabItemContext = React.createContext((_: string): void => undefined)
const { Consumer, Provider } = TabItemContext

export const TabProvider = Provider
export const TabConsumer = Consumer

export const useRegisterTab = (fieldName: string) => {
  const registerTab = React.useContext(TabItemContext)

  React.useEffect(() => {
    registerTab(fieldName)
  }, [])
}

class TabItem extends React.Component<ITabItemProps & Partial<InjectedProps>> {
  register = (field: string) => {
    this.props.registerField && this.props.registerField(this.props.name, field)
  }

  render() {
    return <Provider value={this.register}>{this.props.children}</Provider>
  }
}

export default TabItem
